
import { api } from '../core';
import { User } from '../../types';
import { localDB } from '../helpers';

export const AuthService = {
  // --- Modern OIDC Handling is done via 'oidc-react' hooks in the UI ---
  
  // This method is kept for simulating a fallback manual login (dev/demo mode)
  login: async (email: string, name?: string): Promise<User> => {
    return api.execute<User>(
      '/api/V1/ApplicationUser/GetByLanguage',
      async () => {
        // Fix: User interface uses 'role' instead of 'isAdmin'
        const user: User = {
          id: 'local_user_' + Date.now(),
          name: name || 'Local User',
          email: email,
          plan: 'free',
          role: email.includes('admin') ? 'admin' : 'user',
          avatar: undefined
        };
        localDB.set('lahja_user', user);
        return user;
      },
      { method: 'POST', body: { email } }
    ).catch(async () => {
        // Fix: User interface uses 'role' instead of 'isAdmin'
        const user: User = {
          id: 'user_' + Math.floor(Math.random() * 10000),
          name: name || 'User',
          email: email,
          plan: 'free',
          role: email.includes('admin') ? 'admin' : 'user'
        };
        localDB.set('lahja_user', user);
        return user;
    });
  },

  logout: async (): Promise<void> => {
    localStorage.removeItem('lahja_user');
    localStorage.removeItem('lahja_token');
  }
};